import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Separator } from '@/components/ui/separator';
import { uploadImage } from '@/lib/api/images';
import { ImageForm } from './imageForm';

function submitImage(data: any) {
  return uploadImage({
    file: data.file,
    name: data.name,
  });
}

export default function CreateImage() {
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: submitImage,
    onSuccess: () => {
      navigate('/images');
    },
    onError: (error) => {
      console.error('Error creating image:', error);
    },
  });

  const onSubmit = (data: any) => {
    mutation.mutate(data);
  };

  return (
    <div className="w-full pb-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Create image</h1>
        </div>
      </div>

      <Separator className="my-6" />

      <ImageForm onSubmit={onSubmit} mutation={mutation} />
    </div>
  );
}
